export const companySizeOptions = [
  { label: '1 - 10', value: 1 },
  { label: '11 - 50', value: 2 },
  { label: '51 - 200', value: 3 },
  { label: '201 - 1,000', value: 4 },
  { label: '1,001 - 5,000', value: 5 },
  { label: '5,000+', value: 6 },
];

export const employmentTypeOptions = [
  { label: 'Full-time', value: 'full_time' },
  { label: 'Part-time', value: 'part_time' },
  { label: 'Contract', value: 'contract' },
  { label: 'Internship', value: 'internship' },
  { label: 'Temporary', value: 'temporary' },
  { label: 'Freelance', value: 'freelance' },
  { label: 'Remote', value: 'remote' },
];

export const locationRadiusOptions = [
  {
    label: 'Within 10 miles (16km)',
    value: 10,
  },
  {
    label: 'Within 25 miles (40km)',
    value: 20,
  },
  {
    label: 'Within 50 miles (80km)',
    value: 50,
  },
  {
    label: 'Within 100 miles (160km)',
    value: 100,
  },
  {
    label: 'Within 200 miles (320km)',
    value: 200,
  },
];

export const jobTitlesIncludedOptions = [
  {
    label: 'Current',
    value: 'current',
  },
  {
    label: 'Current and past',
    value: 'all',
  },
];

export const companyNameIncludedOptions = [
  {
    label: 'Current',
    value: 'current',
  },
  {
    label: 'Current and past',
    value: 'all',
  },
  {
    label: 'Specific period',
    value: 'specific_period',
  },
];

export const jobTitlesMatchOptions = [
  {
    label: 'Contains',
    value: 'contains',
    description: 'Include job titles that contain selected terms.',
  },
  {
    label: 'Exact only',
    value: 'exact',
    description: 'Include job titles that are exactly the terms.',
  },
];

export const fundOptions = [
  {
    index: 0,
    label: 'Pre-seed',
    value: 'pre_seed',
  },
  {
    index: 1,
    label: 'Seed',
    value: 'seed',
  },
  {
    index: 2,
    label: 'Series A',
    value: 'series_a',
  },
  {
    index: 3,
    label: 'Series B',
    value: 'series_b',
  },
  {
    index: 4,
    label: 'Series C+',
    value: 'series_c_plus',
  },
  {
    index: 5,
    label: 'Private equity',
    value: 'private_equity',
  },
  {
    index: 6,
    label: 'IPO',
    value: 'ipo',
  },
  {
    index: 7,
    label: 'ICO',
    value: 'ico',
  },
];

export const resumeOptions = [
  { label: 'Any', value: 'any' },
  { label: 'Only contacts with resume', value: 'with_resume' },
  { label: 'Only contacts without resume', value: 'without_resume' },
];

export const signUpDayOptions = [
  { label: 'Any', value: 'any' },
  { label: 'Last 7 days', value: 7 },
  { label: 'Last 30 days', value: 30 },
  { label: 'Last 90 days', value: 90 },
  { label: 'Last year', value: 365 },
];

export const jobSearchStatusesOptions = [
  { label: 'Actively looking', value: 'actively_looking' },
  { label: 'Open to the right opportunity', value: 'casually_browsing' },
  { label: 'Not looking for a change', value: 'not_looking' },
];

export const signupSenioritiesOptions = [
  { label: 'Internship', value: 'internship' },
  { label: 'Entry level', value: 'entry_level' },
  { label: 'Mid-senior level', value: 'mid-senior_level' },
  { label: 'Manager', value: 'manager' },
  { label: 'Director', value: 'director' },
  { label: 'Executive', value: 'executive' },
];

export const signupWorkEnvironmentsOptions = [
  { label: 'Onsite', value: 'onsite' },
  { label: 'Hybrid', value: 'hybrid' },
  { label: 'Remote', value: 'remote' },
];

export const signupInfoOptions = [
  { label: 'Include', value: 'any' },
  { label: "Don't include", value: 'not_completed' },
  { label: 'Only signups', value: 'completed' },
];

export const inPortcoOptions = [
  { label: 'Include', value: 'any' },
  { label: "Don't include", value: false },
  { label: 'Only contacts at companies in network', value: true },
];

export const enrichmentStatusOptions = [
  { label: 'Any', value: 'any' },
  { label: 'Enriched', value: 'enriched' },
  { label: "Couldn't enrich", value: 'not_enriched' },
];

export const contactSourceOptions = [
  {
    label: 'Manual',
    value: ['browser_extension_single_contact_import', 'admin_portal_single_contact_import'],
  },
  {
    label: 'Applied to a job',
    value: ['job_application'],
  },
  {
    label: 'Imported via CSV',
    value: ['csv_import'],
  },
  {
    label: 'Job Board',
    value: ['job_board'],
  },
  {
    label: 'Joined Talent Network',
    value: ['tn_onboarding'],
  },
  {
    label: 'Shared by a team member',
    value: ['shared'],
  },
  {
    label: 'Synced from Integration / API',
    value: ['client_api_bulk_import'],
  },
];

export const jobApplicationsOptions = [
  { label: 'Any', value: 'any' },
  { label: 'One or more', value: '1' },
  { label: 'None', value: '0' },
];

export const jobApplicationBoostOptions = [
  { label: 'Not boosted', value: '' },
  { label: 'Needs calibration', value: 'needs_calibration' },
  { label: 'Preparing boost', value: 'calibrating' },
  { label: 'Ready to launch', value: 'ready_to_launch' },
  { label: 'In progress', value: 'in_progress' },
  { label: 'Completed', value: 'finished' },
];

export const defaultFilters = {
  companyName: [],
  companyDomain: [],
  keywords: [],
  jobTitles: [],
  industryTags: [],
  skills: [],
  companyStages: [],
  importerIds: [],
  seniorities: [],
  jobTitlesMatch: {
    label: 'Contains',
    value: 'contains',
  },
  jobTitlesIncluded: {
    label: 'Current',
    value: 'current',
  },
  locationRadius: {
    label: 'Within 10 miles (16km)',
    value: 10,
  },
  sharedListIds: [],
  activePositionsOrganizationStages: [],
  stageTransitions: [],
  sources: [],
  jobApplicationsJobs: [],
};

export const blacklistedFiltersForCount = [
  'jobTitlesIncluded',
  'jobTitlesMatch',
  'companyStagesYears',
  'companyNameIncluded',
  'industryTagsYears',
  'locationRadius',
  'companyIds',
  'sortBy',
  'sortDirection',
];

export const seniorityOptions = [
  { label: 'Internship', value: 'internship' },
  { label: 'Entry Level', value: 'entry_level' },
  { label: 'Associate', value: 'associate' },
  { label: 'Mid-Senior Level', value: 'mid_senior' },
  { label: 'Senior', value: 'senior' },
  { label: 'Director', value: 'director' },
  { label: 'Vice president', value: 'vice_president' },
  { label: 'CXO', value: 'cxo' },
  { label: 'Founder', value: 'founder' },
  { label: 'Strategic', value: 'strategic' },
];

export const contactsSortOptions = [
  { field: 'relevance', label: 'Relevance', value: 'relevance' },
  { field: 'name', label: 'Name', value: 'name' },
  { field: 'jobTitle', label: 'Current job title', value: 'job_title' },
  { field: 'location', label: 'Location', value: 'location_name' },
  { field: 'seniority', label: 'Seniority', value: 'seniority' },
  { field: 'company', label: 'Current company', value: 'company_name' },
  { field: 'companyFunding', label: 'Current company funding stage', value: 'company_stage' },
  { field: 'companySize', label: 'Current company size', value: 'company_size' },
  { field: 'contactOf', label: 'Number of connections', value: 'number_of_connections' },
  { field: 'yearsOfExperience', label: 'Years of experience', value: 'years_of_experience' },
  { field: 'yearsInCurrentCompany', label: 'Years in current company', value: 'years_in_current_company' },
  { field: 'signupDate', label: 'Talent network signup date', value: 'signup_date' },
  { field: 'firstSeen', label: 'First seen', value: 'added_date' },
];
